import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/Button';

const ServiceDetailContainer = styled.div`
  max-width: 1200px;
  margin: 100px auto 2rem;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 2rem;
`;

const ServiceContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-bottom: 3rem;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const ServiceText = styled.div`
  p { margin-bottom: 1.5rem; line-height: 1.8; color: ${props => props.theme.colors.text}; }
  ul { margin-bottom: 2rem; }
  li { margin-bottom: 0.5rem; color: ${props => props.theme.colors.text}; }
`;

const ServiceImage = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  img { width: 100%; height: 100%; object-fit: cover; background-color: #1e3a8a; }
`;

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  
  const services = [
    { id: "dementia-care", title: "Dementia Care", image: "/images/dementia-care.jpg", description: "Specialized support for individuals living with dementia across the West Midlands.", details: ["Personalized care plans", "Memory stimulation", "Dignified assistance"] },
    { id: "agency-staffing", title: "Agency Staffing", image: "/images/agency-staffing.jpg", description: "Qualified healthcare professionals for West Midlands care homes.", details: ["Nurses & HCAs", "24/7 coverage", "Vetted staff"] },
    { id: "live-in-care", title: "Live-In Care (24/7)", image: "/images/live-in-care.jpg", description: "Round-the-clock support in the comfort of your own home.", details: ["24/7 companionship", "Safety monitoring", "Meal prep"] },
    { id: "care-professionals", title: "Care Professionals", image: "/images/care-professionals.jpg", description: "Compassionate caregivers tailored to your needs.", details: ["One-on-one support", "Flexible scheduling", "Vetted experts"] },
    { id: "personal-care", title: "Personal Care", image: "/images/personal-care.jpg", description: "Assistance with daily living and hygiene with respect.", details: ["Grooming & Bathing", "Medication help", "Mobility support"] },
    { id: "mental-health", title: "Mental Health Support", image: "/images/mental-health.jpg", description: "Promoting emotional wellbeing and stability.", details: ["Emotional support", "Therapeutic activities", "Crisis coordination"] }
  ];
  
  useEffect(() => {
    const found = services.find(s => s.id === id);
    if (found) { setService(found); } else { navigate('/services'); }
  }, [id, navigate, services]);
  
  if (!service) return <ServiceDetailContainer><p>Loading...</p></ServiceDetailContainer>;
  
  return (
    <ServiceDetailContainer>
      <PageTitle>{service.title}</PageTitle>
      <ServiceContent>
        <ServiceText>
          <p>{service.description}</p>
          <h3>Our {service.title} includes:</h3>
          <ul>{service.details.map((d, i) => <li key={i}>{d}</li>)}</ul>
          <Button to="/contact" color="secondary">Inquire Now</Button>
        </ServiceText>
        <ServiceImage><img src={service.image} alt={service.title} /></ServiceImage>
      </ServiceContent>
    </ServiceDetailContainer>
  );
};

export default ServiceDetail;
